import { FunctionComponent, ReactNode } from "react";
import { Avatar, Tooltip } from "antd";
import { KeyOutlined, LogoutOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";

interface AccountFooterProps {
    /** Ferme le drawer (mobile). Inutile côté Sider desktop. */
    onNavigate?: () => void;
    /** Sider desktop replié : icônes seules + tooltips. Toujours false pour le drawer. */
    collapsed?: boolean;
}

export const AccountFooter: FunctionComponent<AccountFooterProps> = ({ onNavigate, collapsed = false }) => {
    const { username, prenom, logout } = useAuth();
    const displayName = prenom ?? username;

    const navigate = useNavigate();

    const handleChangePassword = () => {
        onNavigate?.();
        navigate("/changePassword");
    };

    const handleLogout = () => {
        onNavigate?.();
        logout?.();
    };

    const renderAction = (label: string, icon: ReactNode, onClick: () => void, testid: string) => {
        const button = (
            <button type="button" className="app-account-footer-action" onClick={onClick} aria-label={label} {...({ testid } as any)}>
                {icon}
                {!collapsed && <span>{label}</span>}
            </button>
        );
        return collapsed ? (
            <Tooltip key={label} title={label} placement="right">
                {button}
            </Tooltip>
        ) : (
            <span key={label}>{button}</span>
        );
    };

    return (
        <div className={`app-account-footer${collapsed ? " app-account-footer--collapsed" : ""}`}>
            <div className="app-account-footer-user">
                <Avatar size="small" style={{ backgroundColor: "orange", color: "black", flexShrink: 0 }}>
                    {displayName?.charAt(0).toUpperCase()}
                </Avatar>
                {!collapsed && <span className="app-account-footer-name">{displayName}</span>}
            </div>
            {renderAction("Modifier mot de passe", <KeyOutlined />, handleChangePassword, "change-password")}
            {renderAction("Se déconnecter", <LogoutOutlined />, handleLogout, "logout")}
        </div>
    );
};
